const asyncChildren = [
  {
    id: 5,
    name: 'Child 1__1',
    children: [
      {
        id: 15,
        name: 'Child 1__1__0',
      },
      {
        id: 8,
        name: 'Child 1__1__1',
        children: [
          {
            id: 9,
            name: 'Child 1__1__1__1',
          },
          {
            id: 10,
            name: 'Child 1__1__1__2',
          },
        ],
      },
    ],
  },
  {
    id: 6,
    name: 'Child 1__2',
  },
  {
    id: 7,
    name: 'Child 1__3',
  },
]

const getChildren1 = () => new Promise((resolve) => setTimeout(() => resolve([
  {
    id: 4,
    name: 'Child 2__1',
  },
]), 1000))


export const smallData = {
  id: 1,
  name: 'Parent 1',
  children: [
    {
      id: 2,
      name: 'Child 1',
      children: asyncChildren,
    },
    {
      id: 3,
      name: 'Child 2',
      getChildren: getChildren1,
    },
  ],
}


export const data = {
  id: 1,
  name: 'Chief Executive Officer',
  title: 'CEO',
  children: [
    {
      id: 2,
      name: 'Chief Revenue Officer',
      title: 'CRO',
      children: [
        {
          id: 6,
          name: 'Sales',
        },
        {
          id: 7,
          name: 'Marketing',
        },
        {
          id: 8,
          name: 'Customer Sucess',
        },
      ]
    },
    {
      id: 3,
      name: 'Chief Technology Officer',
      title: 'CTO',
      children: [
        {
          id: 9,
          name: 'Product',
        },
        {
          id: 10,
          name: 'Dev',
        },
        {
          id: 11,
          name: 'Quality management',
        },
      ]
    },
    {
      id: 4,
      name: 'Chief Operating Officer',
      title: 'COO',
      children: [
        {
          id: 12,
          name: 'Business Performance',
        },
        {
          id: 13,
          name: 'Operations',
        },
      ]
    },
    {
      id: 5,
      name: 'Chief Financial Officer',
      title: 'CFO',
      children: [
        {
          id: 14,
          name: 'Controlling',
        },
        {
          id: 15,
          name: 'HR',
        },
      ]
    },
  ]
}
